<div class="timeline-wrapper" [class.advanced-deal]="advancedDeal">
    <div class="time-line-header-wrapper" [class.advanced-deal]="advancedDeal">
        <h2 class="mb-0">Timeline</h2>
    </div>
    <div class="timeline-content">
        <div class="timeline-row" [class.advanced-deal]="advancedDeal">
            <h4 class="mb-0 status-column">
                Deal Started
            </h4>
          <div class="tw-grid tw-grid-flow-col tw-gap-4">
            <div data-cy="deal-create-date">
              {{ dealCreatedFormattedTimeStamp !== false ? (dealCreatedFormattedTimeStamp | date: 'MM/dd/yyyy'): '' }}
            </div>
            <div data-cy="deal-create-time">
              {{ dealCreatedFormattedTimeStamp !== false ? (dealCreatedFormattedTimeStamp | date: 'hh:mm a'): '' }}
            </div>
          </div>

        </div>
        <div *ngIf="dealApplications">
            <div 
              class="timeline-row"
              [class.advanced-deal]="advancedDeal"
              *ngFor="let app of sortBy('createdTimestamp')
              trackBy:trackByAppId">
                <div class="tw-flex">
                  <h4 class="mb-0">Package Sent</h4>
                    <div *ngIf="app.approved === 0 || app.approved === 1;">
                      <div class="api-{{ app.approved === 0 ? 'error' : 'success' }}">
                        <mat-icon class="api-icon">check_circle</mat-icon>
                        Submission {{ app.approved === 0 ? 'Errored' : 'Succeeded' }} via API
                      </div>
                    </div>
                </div>
              <div class="tw-grid tw-grid-flow-col tw-gap-4">
                <div data-cy="package-sent-date">
                  {{app.createdTimestamp * 1000 | date: 'MM/dd/yyyy'}}
                </div>
                <div data-cy="package-sent-time">
                  {{app.createdTimestamp * 1000 | date: 'hh:mm a'}}
                </div>
              </div>
            </div>
            <div *ngIf="dealDateClosed" class="timeline-row" [class.advanced-deal]="advancedDeal">
                <h4 class="mb-0">
                    Deal Closed <span *ngIf="closerName" class="closer">by {{ closerName }} </span>
                </h4>
                <div class="edit-column" [style.visibility]="userCanEditFundedDetails ? 'inherit': 'hidden'">
                    <span
                    *ngIf="!editing"
                    interactive
                    data-cy="closer-edit-btn"
                    (click)="handleEditClosedBy()">
                      Edit
                    </span>
                </div>

              <div class="tw-grid tw-grid-flow-col tw-gap-4">
                <div class="date-column">
                  {{dealDateClosed | date: 'MM/dd/yyyy'}}
                </div>
                <div class="time-column">
                  {{dealDateClosed | date: 'hh:mm a'}}
                </div>
              </div>

            </div>
        </div>
    </div>
</div>
